import {
  Superadmin,
  SuperadminDashboard,
  SuperadminProfile
} from "@/modules/superadmin";

import Logs from "@/components/Logs";

export default [
  {
    path: "/superadmin",
    name: "superadmin",
    component: Superadmin,
    redirect: "/superadmin/tenants",
    meta: {
      isAuthorized: true,
      isAdmin: true
    },
    children: [
      {
        path: "tenants",
        name: "tenants",
        component: SuperadminDashboard
      },
      {
        path: "profile",
        name: "profile",
        component: SuperadminProfile
      },
      {
        path: "logs",
        name: "logs",
        component: Logs
      }
    ]
  }
];
